import { useState } from "react";
import prefersReducedAnimation from "./prefersReducedAnimation";
import getElementsPositions from "./getElementsPositions";

function usePreviousPositionRecording({ reactElements, domElements }) {
  const [positions, setPositions] = useState([]);

  const [elementCount, setElementCount] = useState(0);

  if (elementCount !== reactElements.length) {
    setElementCount(reactElements.length);
  }

  if (elementCount <= reactElements.length) {
    return positions;
  }

  if (!Object.keys(domElements).length) {
    return positions;
  }

  if (prefersReducedAnimation()) {
    return positions;
  }

  setPositions(
    getElementsPositions({
      reactElements,
      domElements
    })
  );

  return positions;
}

export default usePreviousPositionRecording;
